export default __webpack_public_path__ + "static/full_map-c16eb73d28545081226631f6498b66aa.png";